import { create } from 'zustand';
import { supabase } from '@readsavor/supabase-client';
export const useAuthStore = create(set => ({
    session: null,
    status: 'pending',
    queryClient: null,
    isInitialized: false, // Default to false
    isRealtimeReady: false,
    isInitializationComplete: false,
    initialize: (queryClient) => {
        set({ queryClient });
    },
    setSession: (session) => {
        set({ session });
    },
    // 2. Action to explicitly set the authentication status
    setStatus: (status) => {
        set({ status });
    },
    setInitialized: (isInitialized) => {
        set({ isInitialized });
    },
    setRealtimeReady: (isReady) => {
        set({ isRealtimeReady: isReady });
    },
    setInitializationComplete: (isComplete) => {
        set({ isInitializationComplete: isComplete });
    },
    logout: async (queryClient) => {
        try {
            // CRITICAL FIX: Force clear localStorage immediately to prevent recovery
            // Clear all possible Supabase storage keys
            const storageKeys = [
                'readsavor-auth-token',
                'sb-localhost-auth-token',
                'sb-readsavor-auth-token',
                'supabase.auth.token',
            ];
            storageKeys.forEach(key => {
                try {
                    localStorage.removeItem(key);
                    sessionStorage.removeItem(key);
                }
                catch (e) {
                    console.warn(`[Auth] Failed to remove ${key}:`, e);
                }
            });
            // Then try Supabase signOut, but don't wait for it or let it fail the process
            supabase.auth.signOut({ scope: 'local' }).catch((error) => {
                console.warn('[Auth] Supabase signOut failed, but localStorage already cleared:', error);
            });
        }
        catch (error) {
            console.warn('[Auth] Logout cleanup failed, but continuing:', error);
        }
        queryClient.clear();
        set({ session: null, status: 'unauthenticated', isInitializationComplete: false });
    },
}));
//# sourceMappingURL=auth.store.js.map